<template>
    <div class="order-detail">
        <div class="order-detail-header">
            <img :src="require('assets/img/order/kuaidi.png')"/>
            <div>
                {{trackingtips}}
            </div>
        </div>
        <div class="order-detail-body">
            <div class="order-detail-body-trackinfo" v-if="trackingstate!==-1">
                <Cell icon="free-postage" center>
                    <div slot="label">
                        {{orderinfo.express}}:{{orderinfo.trackingno}}
                    </div>
                </Cell>

            </div>
            <Cell icon="location-o" center>
                <div slot="title">收货人:{{orderinfo.name}} {{orderinfo.mobile}}</div>
                <div slot="label">{{orderinfo.city}}{{orderinfo.district}}{{orderinfo.address}}</div>
            </Cell>
        </div>
        <div class="order-detail-goods">
            <Cell class="order-detail-goods-sku" center :value="orderinfo.gname">
                <img :src="orderinfo.gimgurl" slot="icon"/>
            </Cell>
            <CellGroup>
                <Cell title="支付金额" v-if="orderinfo.payprice*1>0">
                    <div slot="default">
                        ¥ {{orderinfo.payprice}}
                    </div>
                </Cell>
                <Cell title="支付积分">
                    <div slot="default">
                        {{orderinfo.point}}
                    </div>
                </Cell>

                <Cell title="订单编号" center :value="orderinfo.orderno"/>
                <Cell title="下单时间">
                    <div slot="default">
                        {{orderinfo.paytime}}
                    </div>
                </Cell>

            </CellGroup>

        </div>
    </div>

</template>
<script>
    import './index.less'
    import {Cell, CellGroup} from 'vant'

    export default {
        data() {
            return {
                orderid: '',
                type: 2,
                orderinfo: '',
                trackingstate: '-1',
                trackingtips: ''
            }
        },
        components: {
            Cell,
            CellGroup
        },
        methods: {
            godetail: function () {
                let goodsid = this.data.orderinfo.gid;
                this.$router.push({name: "exchangedetail", params: {goodsid}})

            },
            getOrderDetail() {
                this.$api.pay.orderDetail({orderid: this.orderid, type: this.type}).then((res) => {
                    if (res.status * 1 === 200) {
                        let trackingtips = '订单处理中';
                        let trackingstate = -1;

                        if (res.data.trackingno !== null && res.data.express !== null) {
                            if (!res.data.selfpoint) {
                                res.data.selfpoint = res.data.point;
                            }
                            this.$api.user.expressinfo({
                                orderno: res.data.orderno,
                                ordertype: this.type
                            }).then((res) => {
                                if (res.status * 1 === 200) {
                                    switch (res.data.state * 1) {
                                        case 0:
                                            trackingtips = "在途中";
                                            break;
                                        case 1:
                                            trackingtips = "已揽收";
                                            break;
                                        case 2:
                                            trackingtips = "疑难";
                                            break;
                                        case 3:
                                            trackingtips = "已签收";
                                            break;
                                        case 4:
                                            trackingtips = "退签";
                                            break;
                                        case 5:
                                            trackingtips = "同城派送中";
                                            break;
                                        case 6:
                                            trackingtips = "退回";
                                            break;
                                        case 7:
                                            trackingtips = "转单";
                                            break;

                                    }
                                    trackingstate = res.data.state;
                                    //保存缓存
                                    this.$storage.set({
                                        key: "expressinfo",
                                        data: res.data.list
                                    })
                                }
                                this.trackingtips = trackingtips
                                this.trackingstate = trackingstate

                            })


                        } else {
                            this.trackingtips = trackingtips
                            this.trackingstate = trackingstate
                        }
                        res.data.gname = res.data.detail[0].gname;
                        res.data.gimgurl = res.data.detail[0].gpimgurl;
                        res.data.gid = res.data.detail[0].gid;
                        this.orderinfo = res.data;


                    }

                })
            },
        },

        mounted: function () {
            this.orderid = this.$route.params.orderid;
            this.getOrderDetail();
        },
    }
</script>
